// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticlePullquote_root__YtnHv"};